module.exports = __webpack_public_path__ + "img/defaultToken.a834d91c.png";